import Illustration1 from "../../assets/offeringsA/SolutionTab/ConversationalAI_Illustration.svg";
import Illustration2 from "../../assets/offeringsA/SolutionTab/KnowledgeAI.svg";
import Illustration3 from "../../assets/offeringsA/SolutionTab/SDLC_AI_Illustration.svg";
import Illustration4 from "../../assets/offeringsA/SolutionTab/AgenticPlatform_Illustration.svg";
import Illustration5 from "../../assets/offeringsA/SolutionTab/HR_Illustration.svg";

const images = [
  Illustration1,
  Illustration2,
  Illustration3,
  Illustration4,
  Illustration5,
];

const SolutionsIllustrations = ({ activeIndex }) => {
  return <img className="w-full" src={images[activeIndex]} alt="" />;
};

export default SolutionsIllustrations;
